export default __webpack_public_path__ + "locales/uk-UA/DeleteProfileEverDialog.json?hash=a63ad464dfeb6e48c056d34d718ad8a7";